import { render, staticRenderFns } from "./CodigoAdesao.vue?vue&type=template&id=5f6ffa44&scoped=true&"
import script from "./CodigoAdesao.vue?vue&type=script&lang=js&"
export * from "./CodigoAdesao.vue?vue&type=script&lang=js&"
import style0 from "./CodigoAdesao.vue?vue&type=style&index=0&id=5f6ffa44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ffa44",
  null
  
)

export default component.exports